import * as React from 'react';
import S from './ArticleMeta.styles';
import { formatDate, formatDateISO } from '@helpers/date';
const ArticleMeta = (props) => {
    return (React.createElement(S.Container, { "data-theme": props.theme },
        props.tag && React.createElement(S.Tag, null, props.tag),
        React.createElement(S.Date, { dateTime: formatDateISO(props.date) }, formatDate(props.date))));
};
export default ArticleMeta;
